/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_DocsInputs */

const en_orders_docs = /** @type {(inputs: Orders_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Docs`)
};

const es_orders_docs = /** @type {(inputs: Orders_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Docs`)
};

/**
* | output |
* | --- |
* | "Docs" |
*
* @param {Orders_DocsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_docs = /** @type {((inputs?: Orders_DocsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_DocsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_docs(inputs)
	return es_orders_docs(inputs)
});